import {reactive} from 'vue'
import axios from 'axios'

// De winkelwagen wordt op elke pagina geladen; de melding moet bewaard blijven tot de klant op de winkelwagenpagina komt.
const REMOVED_LINES_KEY = 'cartRemovedLines'

export default reactive({
    loading: true,
    loaded: false,
    data: {
        lines: [],
    },
    removedLines: JSON.parse(sessionStorage.getItem(REMOVED_LINES_KEY) ?? '[]'),
    addRemovedLines (lines) {
        this.removedLines = [...this.removedLines, ...lines]
        sessionStorage.setItem(REMOVED_LINES_KEY, JSON.stringify(this.removedLines))
    },
    dismissRemovedLines () {
        this.removedLines = []
        sessionStorage.removeItem(REMOVED_LINES_KEY)
    },
    removeSchedule (bundleId, scheduleId) {
        this.loading = true

        axios
            .delete('/api/cart/line/' + bundleId +'/'+ scheduleId)
            .then(response => {

            })
            .catch(response => {

            })
            .finally(() => {
                this.loadCart()
                this.loading = false
            })
    },
    loadCart () {
        this.loading = true

        axios
            .get('/api/cart')
            .then(response => {
                this.data = response.data.data
                this.loaded = true

                if (response.data.removedLines?.length > 0) {
                    this.addRemovedLines(response.data.removedLines)
                }
            })
            .catch(e => {

            })
            .finally(() => {
                this.loading = false
            })
    },
})
